import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import Button from "../../components/ui/Button";

export default function ContactCTA() {
  return (
    <section className="py-12 md:py-16 bg-gold-light/15 border-t border-gold-muted/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <SectionHeading
            overline="Let's Connect"
            title="Ready to elevate your brand?"
            subtitle="Whether you need event management, digital marketing, or strategic business support — we're here to help you achieve excellence."
            align="center"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-6"
        >
          <Link to="/contact">
            <motion.span
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center justify-center font-sans text-sm font-medium tracking-wide px-8 py-3 rounded-sm bg-gold-primary text-aura-text hover:bg-gold-dark hover:text-gold-light transition-colors duration-300"
            >
              Contact Us
            </motion.span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
